import React from 'react';
import { HeroSlider } from '../components/sections/HeroSlider';
import { ServicesSection } from '../components/sections/ServicesSection';
import { ProductGallery } from '../components/sections/ProductGallery';
import { StatsSection } from '../components/sections/StatsSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { CTASection } from '../components/sections/CTASection';

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <HeroSlider />
      <ServicesSection />
      <ProductGallery />
      <StatsSection />
      <TestimonialsSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
